<template>
    <div>
        <div class="row align-items-end">
            <div class="col-md-3 mb-1">
                <label class="form-label">Ödeme Tarih Aralığı</label>
                <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Plasiyer</label>
                <v-select-list :options="salesman" label="Visual" v-model="sm" placeholder="Plasiyer"></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Eczane Kodu</label>
                <input class="form-control" v-model="filter.CariCode" placeholder="Eczane Kodu">
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Eczane Adı</label>
                <input class="form-control" v-model="filter.CariName" placeholder="Eczane Adı">
            </div>
        </div>
        <div class="row align-items-end">
            <div class="col-md-3 mb-1">
                <label class="form-label">Fatura No</label>
                <input class="form-control" v-model="filter.DocumentNo" placeholder="Fatura No">
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Güneş Ürün</label>
                <select class="form-control" v-model="filter.IsSunProductInvoice">
                    <option v-for="o in boolData" :value="o.value" :key="o.value">{{ o.text }}</option>
                </select>
            </div>
            <div class="col-md-2 mb-1">
                <label class="form-label">Taksit Durumu</label>
                <select class="form-control" v-model="filter.IsInstallment">
                    <option :value="null">Tümü</option>
                    <option :value="true">Taksitli</option>
                    <option :value="false">Taksitsiz</option>
                </select>
            </div>
            <div class="col-md-2 mb-1">
                <label class="form-label">Taksit Sayısı</label>
                <select class="form-control" v-model="filter.Installment">
                    <option :value="null">Tümü</option>
                    <option v-for="t in installmentOptions" :value="t" :key="t">{{ t }} Taksit</option>
                </select>
            </div>
            <div class="col-md-2 mb-1 d-flex align-items-end">
                <button class="btn btn-secondary mr-1" v-on:click="$emit('filter',filter)">Filtrele</button>
                <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
            </div>
        </div>
    </div>
</template>

<script>
import { UserApi } from '@/api/user'
import moment from 'moment'
export default {
    data(){
        return{
            filter:{
                PaymentTimeStart: moment().startOf('month').format('YYYY-MM-DD'),
                PaymentTimeEnd: moment().endOf('month').format('YYYY-MM-DD'),
                PlasiyerId: null,
                CariCode: null,
                CariName: null,
                DocumentNo: null,
                IsSunProductInvoice: null,
                Installment: null,
                IsInstallment: null,
            },
            boolData:[
                {text:'Tümü',value:null},
                {text:'Evet',value:true},
                {text:'Hayır',value:false}
            ],
            installmentOptions:[2,3,4,5,6,7,8,9,10,11,12],
            salesman:[]
        }
    },
    mounted(){
        this.getSalesman()
    },
    methods:{
        getSalesman(){
            UserApi.SalesmanList().then(res=>{
                this.salesman = res.data.Data?.map(s=>{
                    return {
                        ...s,
                        Visual:`${s.FullName} - ${s.SalesPersonCode}`
                    }
                })
                this.salesman.unshift({Id:null,Visual:'Tümü',SalesPersonCode:null})
            })
        },
        clearForm(){
            this.filter.PaymentTimeStart = null
            this.filter.PaymentTimeEnd = null
            this.filter.PlasiyerId = null
            this.filter.CariCode = null
            this.filter.CariName = null
            this.filter.DocumentNo = null
            this.filter.IsSunProductInvoice = null
            this.filter.Installment = null
            this.filter.IsInstallment = null
        }
    },
    computed:{
        date:{
            get:function(){
                return [this.filter.PaymentTimeStart,this.filter.PaymentTimeEnd].filter(d=>d != null)
            },
            set:function(val){
                this.filter.PaymentTimeStart = val[0] || null
                this.filter.PaymentTimeEnd = val[1] || null
            }
        },
        sm:{
            get:function(){
                return this.salesman.find(r=>r.Id == this.filter?.PlasiyerId)
            },
            set:function(value){
                this.filter.PlasiyerId = value?.Id || null
            }
        }
    }
}
</script>
